
import { createFormItem } from "@/component-create/utils/create-form-item";
import { FORM_ITEM } from "@/components/form/enums";

export const searchFormItems = [
  createFormItem('锚位', 'anchorPoint', FORM_ITEM.INPUT, {placeholder:'锚位', maxlength:'50',clearable:'true', }),
]

export const editFormItems = [
     [
       createFormItem('锚位', 'anchorPoint', FORM_ITEM.INPUT, {placeholder:'锚位', maxlength:'50',clearable:'true', }),
       createFormItem('使用标记', 'useFlag', FORM_ITEM.SELECT, {loader: 'CL_EOD',allOption: false,}),
     ],
     [
       createFormItem('经度', 'longitude', FORM_ITEM.INPUT_NUMBER, {placeholder:'经度', min:"-180", max:"180", precision:"6" }),
       createFormItem('纬度', 'latitude', FORM_ITEM.INPUT_NUMBER, {placeholder:'纬度', min:"-90", max:"90", precision:"6" }),
     ],
     [
       createFormItem('心跳编码', 'anchorPointHeart', FORM_ITEM.INPUT, {placeholder:'心跳编码', maxlength:'30',clearable:'true', disabled:'true', }),
       createFormItem('指令编码', 'anchorPointOrder', FORM_ITEM.INPUT, {placeholder:'指令编码', maxlength:'30',clearable:'true', disabled:'true', }),
     ],
     [
       createFormItem('定位验证', 'locationVerification', FORM_ITEM.SELECT, {loader: 'CL_EOD',allOption: false,}),
     ],
]

export const addFormItems = [
  [
   createFormItem('锚位', 'anchorPoint', FORM_ITEM.INPUT, {placeholder:'锚位', maxlength:'50',clearable:'true', }),
   createFormItem('使用标记', 'useFlag', FORM_ITEM.SELECT, {loader: 'CL_EOD',allOption: false,}),
  ],
  [
   createFormItem('经度', 'longitude', FORM_ITEM.INPUT_NUMBER, {placeholder:'经度', min:"-180", max:"180", precision:"6" }),
   createFormItem('纬度', 'latitude', FORM_ITEM.INPUT_NUMBER, {placeholder:'纬度', min:"-90", max:"90", precision:"6" }),
  ],
  [
   createFormItem('心跳编码', 'anchorPointHeart', FORM_ITEM.INPUT, {placeholder:'心跳编码', maxlength:'30',clearable:'true', }),
   createFormItem('指令编码', 'anchorPointOrder', FORM_ITEM.INPUT, {placeholder:'指令编码', maxlength:'30',clearable:'true', }),
  ],
  [
   createFormItem('定位验证', 'locationVerification', FORM_ITEM.SELECT, {loader: 'CL_EOD',allOption: false,}),
  ],
]

export const addRules = {
  anchorPoint: [{ required: true, message: '锚位', trigger: 'blur' },
    { min: 1, max: 50, message: '不能少于1个字符,不能超过50个字符', trigger: 'blur' },],
  useFlag: [{ required: true, message: '使用标记', trigger: 'blur' },],
  longitude: [{ required: true, message: '经度', trigger: 'blur' },],
  latitude: [{ required: true, message: '纬度', trigger: 'blur' },],
  anchorPointHeart: [{ required: true, message: '心跳编码', trigger: 'blur' },
    { min: 1, max: 30, message: '不能少于1个字符,不能超过30个字符', trigger: 'blur' },],
  anchorPointOrder: [{ required: true, message: '指令编码', trigger: 'blur' },
    { min: 1, max: 30, message: '不能少于1个字符,不能超过30个字符', trigger: 'blur' },],
  locationVerification: [{ required: true, message: '定位验证', trigger: 'blur' },],
}
export const editRules = {
  anchorPoint: [{ required: true, message: '锚位', trigger: 'blur' },
    { min: 1, max: 50, message: '不能少于1个字符,不能超过50个字符', trigger: 'blur' },],
  useFlag: [{ required: true, message: '使用标记', trigger: 'blur' },],
  longitude: [{ required: true, message: '经度', trigger: 'blur' },],
  latitude: [{ required: true, message: '纬度', trigger: 'blur' },],
  locationVerification: [{ required: true, message: '定位验证', trigger: 'blur' },],
}